import { useMemo, useState } from "react";
import style from "./CourseCategoryCards.module.css";
import Icon from "@/ui/icon/Icon";
import { useNavigate, useLocation } from "react-router-dom";

const categoryColors = {
	prirodni: {
		slug: "prirodni",
		color: "purple",
		// icon: "fa-briefcase-blank",
		icon: "fa-calculator-simple",
	},
	jezici: {
		slug: "jezici",
		color: "blue",
		// icon: "fa-desktop",
		icon: "fa-earth",
	},
	extra: {
		slug: "extra",
		color: "orange",
		// icon: "fa-palette",
		icon: "fa-box",
	},
};

function CourseCategoryCards({
	categories,
	selectedCategory,
	setSelectedCategory,
}) {
	const navigate = useNavigate();
	const location = useLocation();

	const categoriesWithColors = useMemo(() => {
		// Ensure cards follow the explicit order defined in categoryColors
		const order = Object.keys(categoryColors);
		return order
			.map((key) => categories.find((c) => c.slug === key))
			.filter(Boolean)
			.map((category) => ({
				...category,
				...categoryColors[category.slug],
			}));
	}, [categories]);

	const handleCategorySelect = (category) => {
		const newCategory =
			category.slug === selectedCategory ? null : category.slug;
		setSelectedCategory(newCategory);

		// Update URL with query parameter
		const searchParams = new URLSearchParams(location.search);
		if (newCategory) {
			searchParams.set("category", newCategory);
		} else {
			searchParams.delete("category");
		}
		navigate(`${location.pathname}?${searchParams.toString()}`);
	};

	return (
		<>
			{categoriesWithColors.map((category) => (
				<CategoryCard
					key={category.name}
					category={category}
					isSelected={selectedCategory === category.slug}
					onSelect={() => handleCategorySelect(category)}
				/>
			))}
		</>
	);
}

function CategoryCard({ category, isSelected, onSelect }) {
	const { name, color, icon, courseCount } = category;
	const isDisabled = courseCount === 0;

	return (
		<div
			className={`${style.card} ${isSelected ? style.active : ""} ${
				isDisabled ? style.disabled : ""
			}`}
			onClick={!isDisabled ? onSelect : null}
		>
			<div
				style={{ "--color": color }}
				className={style.background}
			></div>
			<div className={style.info}>
				<div className={style.name}>
					<div className={style.icoHolder}>
						<Icon icon={icon} />
					</div>
					<h3>{name}</h3>
				</div>
				<div className={style.count}>
					<span>predmeta:</span>
					<span>{courseCount}</span>
				</div>
			</div>
		</div>
	);
}

export default CourseCategoryCards;
